var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "row col-xs-6" }, [
    _c("div", { staticClass: "col-xs-3 col-sm-2" }, [
      _c("img", { attrs: { src: _vm.talent.profile_image_url, alt: "" } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-9 col-sm-6" }, [
      _c("div", { staticClass: "details" }, [
        _c("p", [
          _c("strong", [_vm._v(_vm._s(_vm.talent.name))]),
          _vm._v(" "),
          _vm.talent.management && !_vm.$userIsManager
            ? _c("i", {
                staticClass: "fa fa-fw fa-group",
                attrs: {
                  "aria-label": _vm.talent.management.company,
                  title: _vm.talent.management.company,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.talent.profile.visibility === "hidden" &&
          (_vm.$userIsAdmin || _vm.$userIsManager)
            ? _c("i", {
                staticClass: "fa fa-eye-slash",
                attrs: { "aria-label": "hidden", title: "hidden" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.talent.profile.visibility === "private" &&
          (_vm.$userIsAdmin || _vm.$userIsManager)
            ? _c("i", {
                staticClass: "fa fa-lock",
                attrs: { "aria-label": "private", title: "private" },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.talent.profile.tagline))]),
        _vm._v(" "),
        _vm.talent.is_recommended
          ? _c("p", { staticClass: "brand-primary" }, [_vm._v("Recommended")])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-6 col-sm-2" }, [
      !_vm.talentIsAlreadyAdded && _vm.talent.is_recommended
        ? _c("div", [
            _vm.talentIsAlreadyRejected
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-danger",
                    on: {
                      click: function ($event) {
                        return _vm.handleRemoveRejectedTalentCallback(
                          _vm.talent
                        )
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-fw fa-times" })]
                )
              : _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-default",
                    on: {
                      click: function ($event) {
                        return _vm.handleRejectTalentCallback(_vm.talent)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-fw fa-minus" })]
                ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-6 col-sm-2" }, [
      !_vm.talentIsAlreadyRejected
        ? _c("div", [
            _vm.talentIsAlreadyAdded
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-success",
                    on: {
                      click: function ($event) {
                        return _vm.handleRemoveTalentCallback(_vm.talent)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-fw fa-check" })]
                )
              : _c(
                  "a",
                  {
                    staticClass: "btn btn-lg btn-default",
                    on: {
                      click: function ($event) {
                        return _vm.handleAddTalentCallback(_vm.talent)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-fw fa-plus" })]
                ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }